import React from 'react';

import { ItemProvider } from '@common/react/components/Core/ItemProvider/ItemProvider';
import { ItemsProvider } from '@common/react/components/Core/ItemsProvider/ItemsProvider';
import { List } from '@common/typescript/objects/List';

import TestimonialCardModal from '@app/components/Pages/VetTestimonials/TestimonialCardModal';
import VetTesModal from '@app/components/Pages/VetTestimonials/VetTesModal';
import VetTestimonialsBody from '@app/components/Pages/VetTestimonials/VetTestimonialsBody';
import HelmetProvider from '@app/providers/HelmetProvider/HelmetProvider';
import Masthead from '@app/components/UI/MastHead/Masthead';
import vetTesMasthead from '@app/images/content/vet_tes_masthead.png';
import vetTesMastheadMobile from '@app/images/content/mobile/vet_tes_masthead.png';
import { BaseContentPage } from '@app/objects/ContentPage';
import { VetTestimonialsRes } from '@app/objects/VetTestimonialsRes';
import CustomRequestProvider from '@app/providers/CustomRequestProvider/CustomRequestProvider';
import { bodyOverflowRemove, bodyOverflowTransform } from '@app/utils/bodyOverflowTransform';

import '@app/scss/components/vetTestimonials.scss';

interface ContentPage extends BaseContentPage {
	items: List<VetTestimonialsRes>;
}

const VetTestimonials: React.FC = () => {
	const mastHeadText = 'There is no exercise better for the heart than reaching down and lifting people up.';

	const [modalVisible, setModalVisible] = React.useState<boolean>(false);

	const [cardsCount, setCardsCount] = React.useState<number>(4);
	const [stateSelected, setStateSelected] = React.useState<string>('');

	const [sent, setSent] = React.useState<boolean>(false);

	const openModal = () => {
		setModalVisible(true);
		setSent(false);
	};

	React.useEffect(() => {
		window.scrollTo(0, 0);
		document.querySelector('#react-app')?.scrollTo(0, 0);
		bodyOverflowTransform(true);

		return function cleanOverflow() {
			bodyOverflowRemove();
		};
	}, []);

	return (
		<HelmetProvider<ContentPage>>
			{(page) => (
				<div className="vet-testimonials" id="vet-testimonials">
					<Masthead
						title="Testimonials for Lap of Love Veterinarians"
						imageSrc={vetTesMasthead}
						mobileSrc={vetTesMastheadMobile}
						imageAlt="Senior dog veterinary hospice"
						text={mastHeadText}
						quoteAuthor="John Holmes"
						buttonText={<button type="button" className="btn btn-md btn-primary" onClick={openModal}>
							Submit a testimonial
						</button>}
						onBtnClick={openModal}
					/>

					<CustomRequestProvider>
						<ItemsProvider<VetTestimonialsRes>
							type={`testimonials/${stateSelected}`}
							loadRequest={`testimonials/${stateSelected}`}
							skipInitLoad
							pagination={{
								pageSize: cardsCount,
								total: page.items.count,
							}}
							items={page.items.list}
						>
							<VetTestimonialsBody
								stateSelected={stateSelected}
								setStateSelected={setStateSelected}
								cardsCount={cardsCount}
								setCardsCount={setCardsCount}
								setModalVisible={setModalVisible}
							/>
							<TestimonialCardModal />
						</ItemsProvider>
					</CustomRequestProvider>

					{modalVisible && (
						<CustomRequestProvider requestMethod="POST">
							<ItemProvider<VetTestimonialsRes>
								id={-1}
								type="testimonials"
							>
								<VetTesModal
									modalVisible={modalVisible}
									setModalVisible={setModalVisible}
									sent={sent}
									setSent={setSent}
								/>
							</ItemProvider>
						</CustomRequestProvider>
					)}
				</div>
			)}
		</HelmetProvider>
	);
};

export default VetTestimonials;
